// Updates PDPs descriptions from big commerce
function updatePDP() {
  $('[data-title] a > img[alt="8-policies.jpg"]').remove();
  // replace pdf link images with just text
  $('[data-title] a > img[alt="10-app-rate.jpg"]').replaceWith('<span class="document-link">Application Rate</span>');
  $('[data-title] a > img[alt="6-label-template-copy.jpg"]').replaceWith('<span class="document-link">Label</span>');
  $('[data-title] a > img[alt="5-msds-sheet-template-copy.jpg"]').replaceWith('<span class="document-link">MSDS Sheet</span>');
  // $('[data-title] a > img[alt="4-spec-sheet-copy.jpg"]').replaceWith('<span class="document-link">Spec Sheet</span>');
  // $('[data-title] a > img[alt="2-spec-sheet-copy.jpg"]').replaceWith('<span class="document-link">Spec Sheet</span>');
  $('[data-title] a > img[alt*="spec-sheet-copy.jpg"]').replaceWith('<span class="document-link">Spec Sheet</span>');
  $('[data-title] a > img[alt="3-omri-cert-template-copy.jpg"]').replaceWith('<span class="document-link">OMRI Certificate</span>');
  $('[data-title] a > img[alt="wsds-cert.jpg"]').replaceWith('<span class="document-link">WSDA Certificate</span>');
  $('[data-title] a > img[alt="7-analysis.jpg"]').replaceWith('<span class="document-link">Analysis Info</span>');
  $('[data-title] a > img[alt="fact-sheet.jpg"]').replaceWith('<span class="document-link">Product Fact Sheet</span>');
  $('[data-title] a > img[alt="product-brochure.jpg"]').replaceWith('<span class="document-link">Product Brochure</span>');
  $('[data-title] a > img[alt="cdfa-certificate.jpg"]').replaceWith('<span class="document-link">CDFA Certificate</span>');
  $('[data-title] a > img[alt="handlers-cert.jpg"]').replaceWith('<span class="document-link">Handlers Cert.</span>');
  $('[data-title] a > img[alt="1-tech-bulletin-template-copy.jpg"]').replaceWith('<span class="document-link">Technical Bulletin</span>');
  $('[data-title] a > img[alt="cueva-leafy-veg.jpg"]').replaceWith('<span class="document-link">Leafy Vegetables</span>');
  $('[data-title] a > img[alt="cueva-fruiting-veg-cuc.jpg"]').replaceWith('<span class="document-link">Fruiting, Veg, Cuc</span>');
  $('[data-title] a > img[alt="cueva-1-fireblight.jpg"]').replaceWith('<span class="document-link">Cueva Fireblight</span>');
  $('[data-title] a > img[alt="cueva-berries.jpg"]').replaceWith('<span class="document-link">Cueva Berries &amp; Grapes</span>');
  $('[data-title] a > img[alt="pppres.jpg"]').replaceWith('<span class="document-link">Power Point Presentation</span>');
  $('[data-title] a > img[alt="msds-sheet-template.jpg"]').replaceWith('<span class="document-link">MSDS Sheet</span>');
  $('[data-title] a > img[alt="analysis-info-template.jpg"]').replaceWith('<span class="document-link">Analysis Info</span>');
  $('[data-title] a > img[alt="label-template.jpg"]').replaceWith('<span class="document-link">Label</span>');
  $('[data-title] a > img[alt="omri-cert-template-copy.jpg"]').replaceWith('<span class="document-link">OMRI Certificate</span>');
  $('[data-title] a > img[alt="7-analysis-info-template-copy-2.jpg"]').replaceWith('<span class="document-link">Analysis Info</span>');
  $('[data-title] a > img[alt="spec-sheet.jpg"]').replaceWith('<span class="document-link">Spec Sheet</span>');
  $('[data-title] a > img[alt="tech-bulletin-template.jpg"]').replaceWith('<span class="document-link">Tech Bulletin</span>');
  $('[data-title] a > img[alt="analysis.jpg"]').replaceWith('<span class="document-link">Analysis</span>');
  $('[data-title] a > img[alt="7-analysis-info-template-copy.jpg"]').replaceWith('<span class="document-link">Analysis</span>');
  $('[data-title] a > img[alt="9-detailed-rates.png"]').replaceWith('<span class="document-link">Detailed Rates</span>');
  $('[data-title] a > img[alt="study.png"]').replaceWith('<span class="document-link">Study</span>');
  $('[data-title] a > img[alt="5-msds-sheet-template-copy.jpg" ]').replaceWith('<span class="document-link">SDS</span>');

  
  // remove inline styling
  $('.product-description [style]').attr('style', '');

  var $moreTabs = $('.moretab');
  var $accWrapper = $('<div class="pdp-accordian accordian"><ul></ul></div>');

  $('.expandable-container').append($accWrapper);
  $moreTabs.each(function(){
    var $this = $(this);
    var rowType = $this.attr('data-title');
    var $accordianRow = $(`
      <li class="accordian-row">
        <p>${rowType}<svg aria-hidden="true" focusable="false" role="presentation" width="10" height="8" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path class="icon-chevron-down-left" d="M4 4.5L7 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square"></path>
          <path class="icon-chevron-down-right" d="M4 4.5L1 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square"></path>
          </svg></p>
        <div class="accordian-content"></div>
      </li>`);


    $accordianRow.find('.accordian-content').append($this.children());
    $accWrapper.find('ul').append($accordianRow);
    $this.remove();
  });
};

// alternative sizes are added as metafields. for example product see bone meal
function activateSizeSelect() {
  var $select = $('.size-change-container #size-change');
  var $options = $select.find('option');
  $options.each(function() {
    if(jQuery(this).val().includes(window.location.pathname)) {
      var currentVal = $select.val();
      jQuery(this).attr('selected', 'selected');
      jQuery(this).val(currentVal);
    }
  });

  $select.change(function() {
    if ($select.val() !==  window.location.pathname) {
      window.location.pathname = $select.val();
    }
  });
}

function activateAccordians() {
  $('.accordian .accordian-row .accordian-content').each(function() {
    var elemHeight = this.scrollHeight;
    $(this).attr('data-height', elemHeight);
  });

  $('.accordian .accordian-row > p').click(function() {
    var $parentRow = $(this).closest('.accordian-row');
    var $accordianContent = $parentRow.find('.accordian-content');
    var height = $accordianContent.data('height') + 20;
    if ($parentRow.hasClass('expanded')) {
      $accordianContent.css('height', 0);
    } else {
      $accordianContent.css('height', height);
    }
    $parentRow.toggleClass('expanded');
  });
}


// updates prices to reflect bulk discounted rates
function updatePrices() {
  var defaultPrice = $('.product__price .price__current .money').text();

  var $discountTable = $('.adp-discount-table');
  if ($discountTable.length == 0) return false;
  window.priceFloors = [];
  $discountTable.find('tbody tr').each(function(){
    var $tdOne = $(this).find('td:first-child')
    var firstNum = $tdOne.text().match(/\d+/);
    if (firstNum) priceFloors.push(parseInt(firstNum));
  });

  function findHighestFloor(qty, priceFloors) {
    var currentHighest = null;
    for (var i = 0; i < priceFloors.length; i++) {
      if (qty >= priceFloors[i]) currentHighest = i;
    }
    if (currentHighest !== null) updatePrice(currentHighest);
    else $('.product__price .price__current .money').text(defaultPrice);
  }

  function updatePrice(idx) {
    var newPrice = $('.adp-discount-table tbody tr:eq(' + idx + ') td:last-child span').text();
    $('.product__price .price__current .money').text(newPrice);
  }


  jQuery('body').on('qty-change', function(){
    var qty = parseInt($('[data-quantity-input]').val());
    findHighestFloor(qty, priceFloors);
  });
}

// update bulk discount text
function updateDiscountText() {
  $('.adp-discount-tiers h4').text('Quantity discounts');
}

function pollForDiscounts(cb, waitTime) {
  if ($('.adp-discount-table').length >= 1) return cb();
  else if (waitTime >= 10000) return false;
  else setTimeout(pollForDiscounts.bind(null, cb, waitTime + 1000), 1000);
}

function addVideo() {
  if (window.videoUrl) {
    var finalUrl = window.videoUrl.replace('embed/', 'watch?v=');
    //add https if not have https://
    if (!finalUrl.includes('https://')) {
      finalUrl = 'https://' + finalUrl;
    }
    $('.pdp-accordian ul').append(`
      <li class="accordian-row video-link">
        <p>
          <a href="${finalUrl}" target="_blank">Product Video
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24">
              <path d="M2 24v-24l20 12-20 12z"/>
            </svg>
          </a>
        </p>
      </li>`);
  }
}



function onDomReady() {
  $(updatePDP);
  $(activateAccordians);
  $(addVideo);
  $(pollForDiscounts.bind(null, updatePrices, 0));
  $(pollForDiscounts.bind(null, updateDiscountText));
}


function pollForJQ(cb) {
  if (window.$ && typeof window.$ === 'function') return cb();
  else return setTimeout(pollForJQ.bind(null, cb), 100);
}

pollForJQ(onDomReady);